import React from 'react';
import PropTypes from 'prop-types';
import DoctypesSelectContainer from "./../containers/DoctypesSelectContainer";
import UrgencySelectContainer from "./../containers/UrgencySelectContainer";
import LevelSelectContainer from "./../containers/LevelSelectContainer";
import VasesContainer from "./../containers/VasesContainer";
import DiscountCodeContainer from "./../containers/DiscountCodeContainer";
import SummaryContainer from "./../containers/SummaryContainer";

const OrderDetails = ({onContinueClick = () => {}}) => {
    return (
        <div className="order-form-wr-wr">
            <h1 className="page__title">CV Services</h1>
            <div className="row">
                <div className="col-lg-8">
                    <div className="order-form__part formpart showed formblock" id="block2">
                        <div className="order-form__wrp">



                                <div className="order-form-wrp">
                                    <LevelSelectContainer />
                                    <DoctypesSelectContainer />
                                    <UrgencySelectContainer />
                                </div>

                                <VasesContainer />
                                <DiscountCodeContainer />

                        </div>
                    </div>

                </div>
                <div className="col-lg-4">
                    <div className="price-wrp price-wrp__1">
                        <SummaryContainer />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-8">
                    <div className="form_nav">
                        <div className="btn-wrap">
                            <button id="continue-step-1-btn" className="button button__submit" onClick={onContinueClick}>Continue
                                <svg width="18" height="9" viewBox="0 0 14 7">
                                    <defs><path id="t7uga" d="M255 506v-1h11.98l-2.99-2.3.72-.7 4.3 3.29-.21.2.2.22-4.3 3.3-.7-.72 2.98-2.29z"></path></defs>
                                    <g><g
                                        transform="translate(-255 -502)"
                                        dangerouslySetInnerHTML={{__html: '<use fill="#fff" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#t7uga" />' }}>
                                    </g></g>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

OrderDetails.propTypes = {
    onContinueClick: PropTypes.func
};

export default OrderDetails;